export default [
  {
    path: "timekeeping",
    name: "Chấm công",
    redirect: "/timekeeping/user",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "user",
        name: "Chấm công cá nhân",
        component: () => import("@/views/screens/timekeeping/UserTimeKeeping"),
        meta: {
          requiresAuth: true,
          title: "Chấm công cá nhân",
        },
      },
      {
        path: "detail",
        name: "Thực hiện chấm công",
        component: () =>
          import("@/views/screens/timekeeping/TimeKeepingDetail"),
        meta: {
          requiresAuth: true,
          title: "Cập nhật ngày công",
        },
      },
    ],
  },
  {
    path: "department_timekeeping",
    name: "Chấm công đơn vị",
    component: () =>
      import("@/views/screens/timekeeping/DepartmentTimekeeping"),
    meta: {
      requiresAuth: true,
      title: "Lãnh đạo chấm công",
    },
  },
  {
    path: "office_timekeeping",
    name: "Văn phòng tổng hợp",
    component: () =>
      import("@/views/screens/timekeeping/OfficeTimekeeping"),
    meta: {
      requiresAuth: true,
      title: "Văn phòng tổng hợp ngày công",
    },
  },
  {
    path: "statistical_timekeeping",
    name: "Tổng hợp ngày công",
    component: () =>
      import("@/views/screens/timekeeping/StatisticalTimekeeping"),
    meta: {
      requiresAuth: true,
      title: "Tổng hợp ngày công",
    },
  },
  {
    path: "holiday_manager",
    name: "Quản lý ngày nghỉ",
    component: () => import("@/views/screens/timekeeping/HolidayManager"),
    meta: {
      requiresAuth: true,
      title: "Quản lý ngày nghỉ",
    },
  },
];
